import React from 'react';
import Slide from '@mui/material/Slide';

export default React.forwardRef(({children, ...other}, ref) => {
  return (
    <Slide direction="up" children={children} {...other} ref={ref} />
  )
});